<template>
  <div class="tag-list">
    <div class="tag-list__result">
      <div v-if="isTagListFilled" class="tag-list__result-table">
        <a-search-result-section-header
          :title="title"
          :description="tagCountString"
        />
        <a-tag
          v-for="tag in tagList"
          :key="tag.Slug"
          :tag="tag"
          class="tag-list__tag"
        />
      </div>

      <no-search-results-preview v-else-if="!inProgress" />

      <a-see-more-less
        v-if="isShowMoreVisible"
        class="tag-list__see-more"
        :is-expanded="false"
        :in-progress="inProgress"
        @input="getMoreTags"
      />
    </div>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'

export default {
  name: 'TagSearchResult',
  components: {
    ASeeMoreLess: () => import('shared/ASeeMoreLess'),
    ASearchResultSectionHeader: () =>
      import('shared/ASearchResultSectionHeader'),
    ATag: () => import('shared/ATag'),
    NoSearchResultsPreview: () =>
      import('shared/AGlobalQuicksearch/NoSearchResultsPreview')
  },
  mixins: [mixins.urlGenerators],
  props: {
    title: propValidator([PROP_TYPES.STRING], false),
    tagList: propValidator([PROP_TYPES.ARRAY]),
    tagCount: propValidator([PROP_TYPES.NUMBER], false, null),
    pageCount: propValidator([PROP_TYPES.NUMBER]),
    take: propValidator([PROP_TYPES.NUMBER], false, 20),
    inProgress: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  data() {
    return {
      page: 0
    }
  },
  computed: {
    isShowMoreVisible() {
      return this.pageCount - 1 > this.page || this.inProgress
    },
    isTagListFilled() {
      return !!this.tagList.length
    },
    tagCountString() {
      return this.tagCount === null ? '' : `${this.tagCount} tags`
    }
  },
  methods: {
    getMoreTags() {
      this.$emit('request-tags', {
        take: this.take,
        page: ++this.page
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-list {
  &__link-container {
    padding-top: 45px;

    @include mobile {
      padding-top: 40px;
    }
  }

  &__see-more {
    margin: 30px auto 0 auto;
    height: 32px;

    @include mobile {
      margin: 30px auto 0 auto;
    }
  }

  &__not-found {
    text-align: center;
    font-size: 20px;
    padding: 20px;
  }

  .tag-list__tag {
    margin-top: 55px;
  }

  /deep/ .tag-list__tag span {
    font-size: 22px;

    @include mobile {
      font-size: 16px;
    }
  }
}
</style>
